// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3MsiY","selected":"Chip_selected__2u0aV"};